import React from 'react';
import { Image, Typography } from 'tfc-components';

import agent1 from 'assets/images/home/agent_1.png';
import agent2 from 'assets/images/home/agent_2.png';
import agent3 from 'assets/images/home/agent_3.png';
import Section from 'components/organisms/Section';
import mapModifiers from 'utils/functions';

interface IAgentSection {
  title: string
  description: string[]
  imageUrl: string
}

const agentSectionData: IAgentSection[] = [
  {
    title: 'Create',
    description: [
      'Set your agent up in just a few clicks.',
      'Name your agent, define clear instructions,',
      'and customize the UI to match your brand.',
    ],
    imageUrl: agent1
  },
  {
    title: 'Train & Test',
    description: [
      'Add your documents, help center, and product pages.',
      'Let AI update itself automatically.',
    ],
    imageUrl: agent2,
  },
  {
    title: 'Deploy',
    description: [
      'Go live across all platforms in one click.',
    ],
    imageUrl: agent3,
  },
];

const AgentSection: React.FC = () => {
  const [active, setActive] = React.useState(0);
  return (
    <Section className="p-home_agentSection">
      <Section.Title className="p-home_agentSection_titleSection">
        Your agent, your way
      </Section.Title>
      <div className="p-home_agentSection_wrap">
        {agentSectionData.map((item, index) => (
          <div key={`${item.title}-${index.toString()}`} className="p-home_agentSection_itemWrap">
            <div className={mapModifiers('p-home_agentSection_item', active === index && 'active')}>
              <div className="p-home_agentSection_title" onClick={() => setActive(index)}>
                <Typography.Text
                  fontweight="600"
                  extendClasses="f-18x24"
                >
                  {item.title}
                </Typography.Text>
              </div>
              {/* <Typography.Text fontweight="600" extendClasses="p-home_agentSection_text">
                Your internal AI copilot.
              </Typography.Text> */}
              {item.description.map((line, lineIndex) => (
                <Typography.Text key={`${line}-${lineIndex.toString()}`} extendClasses="p-home_agentSection_text">
                  {line}
                </Typography.Text>
              ))}
            </div>
            <div className={`${mapModifiers('p-home_agentSection_image p-home_agentSection', active !== index && 'hidden')} p-home_agentSection-hover${index + 1}`}>
              <Image imgSrc={item.imageUrl} alt={item.title} ratio={1258 / 840} />
            </div>
          </div>
        ))}
      </div>
    </Section>
  );
};

export default AgentSection;
